import { useParams, Navigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";
import CTASection from "@/components/CTASection";
import { findPost, BLOG_POSTS } from "@/data/content";

export default function BlogDetail() {
  const { slug } = useParams();
  const p = findPost(slug);
  if (!p) return <Navigate to="/blog" replace />;

  return (
    <>
      <SEO title={p.title} description={p.excerpt} />

      <section className="bg-[var(--dm-navy)] text-white">
        <div className="dm-container py-24 lg:py-28">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white"><ArrowLeft className="w-4 h-4" /> All articles</Link>
          <div className="dm-overline text-[var(--dm-emerald)] mt-8">{p.tag}</div>
          <h1 className="font-serif text-4xl sm:text-5xl mt-4 leading-[1.1] max-w-4xl">{p.title}</h1>
          <div className="mt-8 text-xs uppercase tracking-[0.2em] text-white/60">{p.author} · {p.date} · {p.readTime}</div>
        </div>
      </section>

      <section className="bg-white">
        <div className="aspect-[21/9] overflow-hidden max-h-[520px]">
          <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
        </div>
      </section>

      <section className="bg-white">
        <div className="dm-container dm-section grid lg:grid-cols-12 gap-16">
          <article className="lg:col-span-8 prose-lg">
            <p className="font-serif text-2xl text-[var(--dm-navy)] leading-snug">{p.excerpt}</p>
            <div className="mt-8 text-[var(--dm-text)] leading-relaxed whitespace-pre-line text-lg">{p.body}</div>
          </article>
          <aside className="lg:col-span-4">
            <div className="sticky top-28 bg-[var(--dm-surface)] p-8 border border-[var(--dm-border)]">
              <div className="dm-overline">More insights</div>
              <ul className="mt-4 space-y-4">
                {BLOG_POSTS.filter((x) => x.slug !== p.slug).slice(0, 4).map((x) => (
                  <li key={x.slug}>
                    <Link to={`/blog/${x.slug}`} className="block group">
                      <div className="text-sm font-serif text-[var(--dm-navy)] group-hover:text-[var(--dm-emerald)] leading-snug">{x.title}</div>
                      <div className="text-xs text-[var(--dm-muted)] mt-1">{x.tag} · {x.readTime}</div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </section>

      <CTASection />
    </>
  );
}
